export const recursosHumanosRoute: string = 'rh';
export const recursosHumanosModuleName: any = {plural: 'Pessoas', single: 'Pessoa'};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/shared/data.service.ts
 **/